import { render, staticRenderFns } from "./MapSettingsFields.vue?vue&type=template&id=180ae796&scoped=true&"
import script from "./MapSettingsFields.vue?vue&type=script&lang=ts&"
export * from "./MapSettingsFields.vue?vue&type=script&lang=ts&"
import style0 from "./MapSettingsFields.vue?vue&type=style&index=0&id=180ae796&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180ae796",
  null
  
)

export default component.exports